import { z } from "zod";

export const MCP_STATS_DAYS = [7, 30, 90, 365] as const;

/** Filtry kolumn każdej tabeli w URL — po odświeżeniu i zmianie zakładki widok wraca. */
const columnFilters = z
	.array(z.object({ id: z.string(), value: z.unknown() }))
	.optional()
	.catch(undefined);

export const mcpStatsSearchSchema = z.object({
	days: z.coerce
		.number()
		.pipe(z.union([z.literal(7), z.literal(30), z.literal(90), z.literal(365)]))
		.default(30)
		.catch(30),
	view: z
		.enum(["narzedzia", "zbiory", "kolumny", "problemy", "braki", "polaczenia", "dni"])
		.default("narzedzia")
		.catch("narzedzia"),
	toolFilters: columnFilters,
	datasetFilters: columnFilters,
	columnUsageFilters: columnFilters,
	issueFilters: columnFilters,
	gapFilters: columnFilters,
	connectionFilters: columnFilters,
	dayFilters: columnFilters,
});

/** Zakładki z analizy zapytań (`/mcp/stats/insights`) — pobierane dopiero po wejściu. */
export const MCP_INSIGHT_VIEWS = ["zbiory", "kolumny", "problemy", "braki"] as const;

export type McpStatsSearch = z.infer<typeof mcpStatsSearchSchema>;
